var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHideIco(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4242",
    "data-name": "Grupo 4242",
    transform: "translate(-791.111 -268.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3235",
    "data-name": "Grupo 3235",
    transform: "translate(795.111 272.43)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\uCC3Dngulo_2991",
    "data-name": "Ret\\uCC3Dngulo 2991",
    width: 48,
    height: 48,
    rx: 24,
    fill: "#fae3bd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\uCC3Dngulo_2992",
    "data-name": "Ret\\uCC3Dngulo 2992",
    width: 48,
    height: 48,
    rx: 24,
    fill: "none",
    stroke: "#fdf8ed",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_3896",
    "data-name": "Grupo 3896",
    transform: "translate(669 -185)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "comment-icon",
    d: "M8.489,32C3.765,32-.064,35.556-.064,39.944A7.558,7.558,0,0,0,1.7,44.767a9.9,9.9,0,0,1-1.55,2.8A1.017,1.017,0,0,0,0,48.556a.809.809,0,0,0,.738.554,7.483,7.483,0,0,0,4.648-1.768,9.141,9.141,0,0,0,3.1.546c4.725,0,8.554-3.556,8.554-7.944S13.214,32,8.489,32Zm0,14.054a7.69,7.69,0,0,1-2.62-.462l-.758-.275-.652.527a6.9,6.9,0,0,1-1.921,1.108A10.194,10.194,0,0,0,3.2,45.416l.354-1.073-.688-.833a5.627,5.627,0,0,1-1.33-3.567c0-3.368,3.117-6.11,6.95-6.11s6.95,2.742,6.95,6.11S12.322,46.054,8.489,46.054Z",
    transform: "translate(142.315 441.891)",
    fill: "#feac0e",
    stroke: "#667085",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("line", {
    id: "Linha_311",
    "data-name": "Linha 311",
    y2: 5,
    transform: "translate(819.5 295.5)",
    fill: "none",
    stroke: "#feac0e",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Elipse_159",
    "data-name": "Elipse 159",
    transform: "translate(819 293)",
    fill: "#feac0e",
    stroke: "#feac0e",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: 0.5,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHideIco);
export default __webpack_public_path__ + "static/media/hide-ico.e976e4e825dfaf1cd862b58d10e27d3f.svg";
export { ForwardRef as ReactComponent };